var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"interv-img-modal",attrs:{"id":"interv-img-modal","size":"xl"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-12"},[_c('img',{attrs:{"src":_vm.img,"width":"100%"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }